module.exports = __webpack_public_path__ + "static/img_dxzm_0110.ced09fc6.png";